<template>
  <v-container fluid grid-list-xl fill-height>
    <v-layout justify-center align-center>
      <v-flex xs12 sm8 md4>
        <material-card v-if='!maintainance' :color="cardColor" :text="message" title="Services - Login">
          <v-form ref="form" v-model="validForm">
            <v-container py-0>
              <v-alert v-if='announcement' outlined type='error'>{{ announcement }}</v-alert>
              <v-layout wrap>
                <v-flex xs12 md12>
                  <v-text-field v-model="loginForm.username" :rules="validators.username" prepend-icon="mdi-account"
                    name="login" label="Username" type="text" required id="input_login" />
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field id="input_password" v-model="loginForm.password" :append-icon="passwordType == 'password' ? 'mdi-eye' : 'mdi-eye-off'
                    " :type="passwordType" :rules="[validators.password]" prepend-icon="mdi-lock" name="password"
                    label="Password" required @click:append="showPwd" />
                </v-flex>


                <v-flex xs6 text-left>
                  <br>
                  <a id="button_resetPassword" @click="resetPass">Reset password</a>
                </v-flex>


                <v-flex xs6 text-right>
                  <v-btn :disabled="!validForm" color="primary" class="mx-0 font-weight-light" @click="login"
                    id="button_login">Login</v-btn>

                </v-flex>

              </v-layout>
            </v-container>
          </v-form>

        </material-card>
        <v-alert v-else type='error'>
          <h3>Maintainance Mode</h3>
          <h4>{{ maintainance }}</h4>
        </v-alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import validators from '@/utils/validators'
import { mapActions, mapState } from 'vuex'


export default {
  data: () => ({
    validForm: true,
    validators,
    loginForm: {
      username: '',
      password: '',
    },
    passwordType: 'password',
    message: 'Please insert your credentials',
    cardColor: 'primary'
  }),
  computed: {
    ...mapState('app', ['announcement', 'maintainance'])
  },
  mounted() {
    this.getConfig()
  },
  methods: {
    ...mapActions('app', ['getConfig']),
    login() {
      if (!this.$refs.form.validate()) {
        return
      }

      this.$store
        .dispatch('user/login', this.loginForm)
        .then(() => {
          this.cardColor = 'success'
          const path = this.$route.query.redirect || '/'
          this.$router.push({ path })
          this.loading = false
        })
        .catch((e) => {
          this.loading = false
          this.message = e.response.data.message
          this.cardColor = 'error'
          if (e.response && e.response.status === 419) { // Password Expired
            this.$root.$emit('openSnackbar', { message: 'Your password is expired!', color: 'red' })
            this.$router.push('/confirm-reset-pass?exp=1&email='+encodeURIComponent(e.response.data.error_details.email)+'&restore_pass_token='+encodeURIComponent(e.response.data.error_details.
            restore_pass_token))
          }
          if (e.response && e.response.status === 429) { // Too many login request
            this.$root.$emit('openSnackbar', { message: e.response.data.message, color: 'red' })
          }
        })
    },
    resetPass() {
      this.$router.push({ path: '/reset-pass' })
    },
    showPwd() {
      this.passwordType =
        this.passwordType === 'password' ? 'text' : 'password'
    },
  }
}
</script>


<style scoped>
.form-separator {
  height: 12px;
  margin: 0px 0px 20px 0px;
  text-align: center;
  border-bottom: 1px solid #e4e5e7;
}

.form-separator span {
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  padding: 0 8px;
  background-color: #fff;
  color: #62646a;
}

.googleButton {
  margin: auto;
  min-width: 130px;
  background-color: #f4f4f4;
  border: 1px solid gray;
  text-align: left;
  margin-top: 15px;
}

.googleButton span {
  position: absolute;
  margin-top: 7px;
}
</style>